export default __webpack_public_path__ + "static/media/3150.d913b792.jpg";